module.exports = __webpack_public_path__ + "471279e43ea97a201e48ca587e04ebc7.pdf";